var _circle, _line, _line2, _line3, _line4, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FBF6F2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 25.6191,
    x2: 45.7805,
    y2: 25.6191,
    stroke: "#242424",
    strokeWidth: 1.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 33.1309,
    x2: 45.7805,
    y2: 33.1309,
    stroke: "#242424",
    strokeWidth: 1.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 40.6445,
    x2: 45.7805,
    y2: 40.6445,
    stroke: "#242424",
    strokeWidth: 1.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 18.1055,
    x2: 45.7805,
    y2: 18.1055,
    stroke: "#242424",
    strokeWidth: 1.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8294,
    cy: 18.7317,
    r: 2.73171,
    fill: "#242424"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.3167,
    cy: 26.2434,
    r: 2.73171,
    fill: "#242424"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.1223,
    cy: 33.7551,
    r: 2.73171,
    fill: "#242424"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5608,
    cy: 41.2669,
    r: 2.73171,
    fill: "#242424"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon3);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzAiIGN5PSIzMCIgcj0iMzAiIGZpbGw9IiNGQkY2RjIiLz4KPGxpbmUgeDE9IjEzIiB5MT0iMjUuNjE5MSIgeDI9IjQ1Ljc4MDUiIHkyPSIyNS42MTkxIiBzdHJva2U9IiMyNDI0MjQiIHN0cm9rZS13aWR0aD0iMS4yNSIvPgo8bGluZSB4MT0iMTMiIHkxPSIzMy4xMzA5IiB4Mj0iNDUuNzgwNSIgeTI9IjMzLjEzMDkiIHN0cm9rZT0iIzI0MjQyNCIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+CjxsaW5lIHgxPSIxMyIgeTE9IjQwLjY0NDUiIHgyPSI0NS43ODA1IiB5Mj0iNDAuNjQ0NSIgc3Ryb2tlPSIjMjQyNDI0IiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPGxpbmUgeDE9IjEzIiB5MT0iMTguMTA1NSIgeDI9IjQ1Ljc4MDUiIHkyPSIxOC4xMDU1IiBzdHJva2U9IiMyNDI0MjQiIHN0cm9rZS13aWR0aD0iMS4yNSIvPgo8Y2lyY2xlIGN4PSIxOS44Mjk0IiBjeT0iMTguNzMxNyIgcj0iMi43MzE3MSIgZmlsbD0iIzI0MjQyNCIvPgo8Y2lyY2xlIGN4PSI0MC4zMTY3IiBjeT0iMjYuMjQzNCIgcj0iMi43MzE3MSIgZmlsbD0iIzI0MjQyNCIvPgo8Y2lyY2xlIGN4PSIzMi4xMjIzIiBjeT0iMzMuNzU1MSIgcj0iMi43MzE3MSIgZmlsbD0iIzI0MjQyNCIvPgo8Y2lyY2xlIGN4PSIyMi41NjA4IiBjeT0iNDEuMjY2OSIgcj0iMi43MzE3MSIgZmlsbD0iIzI0MjQyNCIvPgo8L3N2Zz4K";